'use strict';

const { appendFilter } = require('../../../queries');
const addPayeeEbillsQueries = require('../../../queries/configs/PayeeEbills');

function PayeeEbills({ client, fspId, payeeId }) {

  return {
    returnModel: {
      name: 'payeeebill',
    },
    baseUrl: `/fsps/${fspId}/payees/${payeeId}/payeeebills`,
    queriesFilter: appendFilter('payeeId', payeeId),

    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = addPayeeEbillsQueries(PayeeEbills);
